import React from "react";
import { useIntl } from "react-intl";
import { ParagraphUtilityCode } from "@/model";
import { isValidParagraphData } from "@/util/helper/paragraphHelper";
import { CodeEditor } from "@/component/input";

import { ParagraphInputsProps } from "../model";


const ParagraphUtilityCodeCardInputs: React.FC<ParagraphInputsProps<ParagraphUtilityCode>> = (props) => {
    const { paragraph, onChange } = props;

    const intl = useIntl();

    return (
        <div className="col-span-2 flex flex-col gap-1.5">
            <div className="h-6 flex items-center field-label">
                {intl.formatMessage({ id: "i04068" })}
            </div>
            <CodeEditor mode="python"
                        value={paragraph.data?.code}
                        height="250px"
                        inValid={!isValidParagraphData(paragraph)}
                        invalidMessage={intl.formatMessage({ id: "i04082" })}
                        onChange={value => onChange({
                            ...paragraph,
                            data: { code: value }
                        })}
            />
        </div>
    );
};

export default ParagraphUtilityCodeCardInputs;
